'use client';

import { useUser } from '@auth0/nextjs-auth0/client';
import { useEffect } from 'react';
import { useSearchParams, useRouter } from 'next/navigation';
import { Center, Spinner } from '@chakra-ui/react';

function LoginPage() {
  const { user, isLoading } = useUser();
  const searchParams = useSearchParams();
  const router = useRouter();
  const loginRedirect = searchParams.get('loginRedirect') || '/projects';

  useEffect(() => {
    if (!isLoading) {
      if (user) {
        router.push(loginRedirect);
      } else {
        router.replace(
          `/api/auth/login?returnTo=${encodeURIComponent(loginRedirect)}`,
        );
      }
    }
  }, [user, isLoading, loginRedirect, router]);

  return (
    <Center h="100vh">
      <Spinner />
    </Center>
  );
}

export default LoginPage;
